import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  .custom-chart {
    .apexcharts-canvas {
      > svg {
        margin-top: -20px !important;
        margin-left: -25px !important;
      }
    }
  }
`;

export const LegendBox = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  margin-top: -25px !important;
`;

export const LegendBoxItem = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 30px;
`;

export const LegendBoxItemLabel = styled.div`
  display: flex;
  flex: 2;
  align-items: center;
  svg {
    font-size: 15px;
    margin-right: 10px;
  }
`;

export const LegendBoxItemPercentage = styled.div`
  color: ${(props) => (props.isPositive ? '#0FB691' : '#FF604E')};
  font-size: 20px;
  font-weight: bold;
  display: flex;
  align-items: flex-end;
  flex: 1;
  white-space: nowrap;
`;
